import { types } from "../actionTypes/ReportActionTypes";

const ReportReducer = (state = [], action) => {
    const { payload } = action
    switch (action.type) {
        case types.GET_REPORT_REQUEST:
            return {
                ...state,
                reportListLoading: true,
            };
        case types.GET_REPORT_SUCCESS:
            return {
                ...state,
                reportListLoading: false,
                reportList: payload.ErrorLog,
                totalRecords: payload.totalRecords
            };
        case types.GET_REPORT_FAILURE:
            return {
                ...state,
                reportListLoading: false,
            };
        default:
            return state;
    }
};

export default ReportReducer;